import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['specifyField', 'raceCheckbox']

  toggleSpecifyField(event) {
    const checked = event.target.checked
    if (checked) {
      this.specifyFieldTarget.style.display = ''
    } else {
      this.specifyFieldTarget.style.display = 'none'
    }
  }
}
